<template>
  <v-btn
    flat
    class="ml-0 pa-0 boiler-button boiler-button-2 mr-0"
    v-if="controllerData"
    @click="$emit('imageNavigation')"
  >
    <div v-if="controllerData.frontdata" class="on-button-text boiler-top-text">
      <p class="mb-0">
        <!-- Smoke temperature -->
        {{ controllerData.frontdata[7].value | tempConversion }}
        {{ controllerData.frontdata[7].unit | translate }}
      </p>
      <p class="mb-0">
        <!-- Oxygen and wanted oxygen -->
        {{ controllerData.frontdata[8].value | tempConversion }}
        {{ controllerData.frontdata[8].unit | translate }} ({{
          controllerData.frontdata[5].value | tempConversion
        }})
      </p>
      <p class="mb-0">
        <!-- Boiler pressure and exhaust fan speed -->
        {{ controllerData.frontdata[9].value | tempConversion }}
        {{ controllerData.frontdata[9].unit | translate }} ({{
          controllerData.frontdata[10].value | tempConversion
        }}
        {{ controllerData.frontdata[10].unit | translate }})
      </p>
    </div>
    <div v-if="controllerData.frontdata" class="on-button-text">
      <p v-if="controllerData.frontdata[1].id === 'boilertemp'" class="mb-0">
        {{ controllerData.frontdata[1].value | tempConversion }}
        {{ controllerData.frontdata[1].unit | translate }}
      </p>
      <p
        v-if="controllerData.frontdata[2].id === '-wantedboilertemp'"
        class="mb-0"
      >
        ({{ controllerData.frontdata[2].value | tempConversion }}
        {{ controllerData.frontdata[2].unit | translate }})
      </p>
    </div>
    <div
      v-if="controllerData.frontdata && toShowAshValue()"
      class="on-button-text boiler-bottom-text"
    >
      <p v-if="controllerData.frontdata[13].id === 'ashdist'" class="mb-0">
        {{ controllerData.frontdata[13].value | tempConversion }}
        {{ controllerData.frontdata[13].unit | translate }}
      </p>
    </div>
    <v-img
      v-if="controllerData.model === '0'"
      :src="require(`../assets/${this.selectBoilerImage(0)}`)"
    ></v-img>
    <v-img
      v-if="controllerData.model === '1'"
      :src="require(`../assets/${this.selectBoilerImage(1)}`)"
    ></v-img>
  </v-btn>
</template>

<script>
export default {
  props: {
    controllerData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    isBetween(value, lower, upper) {
      return lower <= Math.round(value) && Math.round(value) <= upper;
    },
    selectBoilerImage(model) {
      const distance = this.controllerData.frontdata[13].value;
      let basicPath = "";
      if(model === 0){
        basicPath = "bundle0/boiler/";
      } else if(model === 1){
        basicPath = "bundle1/boiler/";
      }

      var image = 0;

      if (
        distance === undefined ||
        distance === "" ||
        distance === null ||
        distance > 100
      ) {
        return `${basicPath}RTB-front.png`;
      }

      if (distance > 82) {
        image = 0;
      } else if (distance > 66) {
        image = 1;
      } else if (distance > 50) {
        image = 2;
      } else if (distance > 34) {
        image = 3;
      } else if (distance > 18) {
        image = 4;
      } else {
        image = 5;
      }

      if (image === 0) {
        return `${basicPath}${model ? "phoenix_kedel_0.png" : "phoenix_kedel_0.png"}`;
      } else if (image === 1) {
        return `${basicPath}${model ? "phoenix_kedel_1.png" : "phoenix_kedel_1.png"}`;
      } else if (image === 2) {
        return `${basicPath}${model ? "phoenix_kedel_2.png" : "phoenix_kedel_2.png"}`;
      } else if (image === 3) {
        return `${basicPath}${model ? "phoenix_kedel_3.png" : "phoenix_kedel_3.png"}`;
      } else if (image === 4) {
        return `${basicPath}${model ? "phoenix_kedel_4.png" : "phoenix_kedel_4.png"}`;
      } else if (image === 5) {
        return `${basicPath}${model ? "phoenix_kedel_5.png" : "phoenix_kedel_5.png"}`;
      }

      return `${basicPath}RTB-front.png`;
    },
    toShowAshValue() {
      const distance = this.controllerData.frontdata[13].value;
      if (
        distance === undefined ||
        distance === "" ||
        distance === null ||
        distance > 100
      ) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
